import { render, staticRenderFns } from "./CompanyShowDetailsTab.vue?vue&type=template&id=b66603da"
import script from "./CompanyShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CompanyShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports